/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcRowSelectCheckbox
 * @restrict E
 * @element div
 * @description
 * The wcRowSelectCheckbox directive is responsible for selecting the row in datatable on a checkbox click.
 */



angular.module('WcResponsiveTableModule').directive('wcRowSelectCheckbox', function () {
	return {
		restrict: 'E',
		template: '<input type="checkbox" class="wc-checkbox-column" name="{{responsiveTableController.id}}-checkbox[]" ng-change="rowSelectCheckboxController.selectRow()" ng-model="responsiveTableController.wcRowSelectCheckbox[rowSelectCheckboxController.index]" ng-true-value="{{rowSelectCheckboxController.rowCheckedMap}}" ng-false-value="{{rowSelectCheckboxController.rowUncheckedMap}}">',
		require: ['wcRowSelectCheckbox', '^wcResponsiveTable', '^ngModel'],
		scope: true,
		controllerAs: 'rowSelectCheckboxController',
		controller: ['$scope', '$element', function ($scope, $element) {
			this.checkbox = $element.find('input');
			this.index = $scope.$parent.index;
			this.rowKey = $scope.$parent.rowKey;
			this.rowCheckedMap = {
				key: this.rowKey,
				value: true
			};
			this.rowUncheckedMap = {
				key: this.rowKey,
				value: false
			};
			this.checked = this.rowUncheckedMap.value;

			var responsiveTableController = $element.parent().controller('wcResponsiveTable');
			responsiveTableController.wcRowSelectCheckbox = responsiveTableController.wcRowSelectCheckbox || [];
			responsiveTableController.wcRowSelectCheckbox[this.index] = this.rowUncheckedMap;

			var tableScope = responsiveTableController.WcTableScopeService.getTableScope();

			this.selectRow = function () {
				$scope.$parent.isSelected = this.checked = responsiveTableController.wcRowSelectCheckbox[this.index].value;

				var selectedItems = _.filter(responsiveTableController.wcRowSelectCheckbox, {value: true});
				var newModel = _.map(selectedItems, function(value) { return value.key; });

				responsiveTableController.ngModel = newModel;
				responsiveTableController.applyModel(responsiveTableController.ngModel);
			};

			tableScope.$on('table.render.complete', angular.bind(this, function () {
				if ($scope.$parent.isSelected) {
					responsiveTableController.wcRowSelectCheckbox[this.index] = this.rowCheckedMap;
					this.checked = this.rowCheckedMap.value;
				}
			}));

			tableScope.$on('table.select.checkbox.all', angular.bind(this, function () {
				if(!this.checked) {
					this.checkbox.click();
				}
			}));

			tableScope.$on('table.select.checkbox.none', angular.bind(this, function () {
				if(this.checked) {
					this.checkbox.click();
				}
			}));
		}],
		link: function (scope, element) {
			var highlightRow = function (shouldHighlight) {
				var row = element.parent().parent();
				if (shouldHighlight) {
					$(row).addClass('wc-highlight-row');
				}
				else {
					$(row).removeClass('wc-highlight-row');
				}
				var tableCells = row.children();
				$(tableCells).each(function (index, cell) {
					// jshint unused:true
					if (shouldHighlight) {
						$(cell).addClass('wc-highlight-row');
					} else {
						$(cell).removeClass('wc-highlight-row');
					}
				});
			};

			scope.$watch('rowSelectCheckboxController.checked', function (boolean) {
				highlightRow(boolean);
			});
		}
	};
});
